import {
  Grid,
  TextField,
  Button,
  Container,
  Typography,
  FormControlLabel,
  Switch,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ApplicationLayout from '../components/layouts/ApplicationLayout';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from 'react-hook-form';
import useSWR from 'swr';
import { toast } from 'react-toastify';
import { useUser } from '../store/user';
import { useFetcher } from '../hooks/useFetcher';
import { LoadingBox } from '../components/LoadingBox';
import _ from 'lodash';
import ChangePasswordContent from '../components/ChangePasswordContent';
import TwoFactorAuthenticationContent from 'components/TwoFactorAuthenticationContent';

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const Security = () => {
  const [{ isLogin, user, isAdmin, isCs }, setUser] = useUser();
  console.log('IsCs', isCs);
  const classes = useStyles();

  const onSubmit = (values) => {
    // console.log(values);
  };

  return (
    <ApplicationLayout>
      <Container component="main" maxWidth="sm">
        <Typography variant="h6" gutterBottom component="div">
          Security
        </Typography>
      </Container>
      <Container maxWidth="sm">
        <Typography variant="h6" gutterBottom component="div">
          Change Password
        </Typography>
        <ChangePasswordContent />
      </Container>
      <Container maxWidth="sm">
        <Typography variant="h6" gutterBottom component="div">
          2-Factor Authentication
        </Typography>
        <TwoFactorAuthenticationContent />
      </Container>
    </ApplicationLayout>
  );
};

export default Security;
